import React from "react";
import { Category } from "../../entities/Category/Category";
import { AddRemoveButton } from "../../components/buttons/AddRemoveButton/AddRemoveButton";
import { MenuItem } from "@dto/MenuItem";
import { NavLink } from "../../navigation/NavLink/NavLink";
import { getEntityUrlPath } from "@lib/getEntityUrlPath";
import { EventDateTime } from "../../event/EventDateTime";
import { Event } from "@dto/Event";
import { Image } from "@ui-kit/Image/Image";
import { VideoPlayerButton } from "../../media/VideoPlayer/VideoPlayerButton";
import { AudioPlayerButton } from "../../media/AudioPlayer/AudioPlayerButton";
import { AdListItem } from "../AdListItem/AdListItem";
import { EntityListItemType } from "../EntityList/EntityList";
import { Place } from "@dto/Place";
import { Text } from "@ui-kit/Text/Text";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

import "./EntityListItem.css";

const EntityListItem = React.forwardRef<
  Element,
  {
    entity: EntityListItemType;
    menuItem: MenuItem;
  }
>(({ entity, menuItem }, ref) => {
  if (entity.type === "Ad") {
    return (
      <span
        ref={ref as React.RefObject<HTMLAnchorElement>}
        className="ad-list-item-container">
        <AdListItem ad={entity} />
      </span>
    );
  }

  return (
    <NavLink
      to={getEntityUrlPath(entity.slug, entity.id, menuItem.entity as any)}
      className="entity-list-item">
      <span ref={ref as React.RefObject<HTMLAnchorElement>}>
        <div className="cover-photo">
          <Image src={entity.coverPhotoUrl} />
          {(entity as Place).formattedListingValue && (
            <div className="formatted-listing-value">
              <Text variant="labelSmall" color={colors.black}>
                {(entity as Place).formattedListingValue}
              </Text>
            </div>
          )}
          {menuItem.entity !== "FeedPost" && (
            <div className="add-remove-button-container">
              <AddRemoveButton id={entity.id} type={menuItem.entity as any} />
            </div>
          )}
          <div className="video-player-button-container">
            <VideoPlayerButton entity={entity} />
          </div>
        </div>
        <div className="entity-name-container">
          <div className="entity-name">{entity.name}</div>
          <AudioPlayerButton entity={entity} variant="list" />
        </div>
        {entity.startsOn && (
          <div className="date-time-container">
            <EventDateTime
              event={entity as unknown as Event}
              variant="compact"
            />
          </div>
        )}
        {!entity.startsOn && (
          <div className="date-time-container">
            <Category entity={entity} />
          </div>
        )}
        {entity.location?.address && (
          <div className="entity-address">{entity.location.address}</div>
        )}
      </span>
    </NavLink>
  );
});

EntityListItem.displayName = "EntityListItem";

export { EntityListItem };
